import Store from '../store/store_user.js'

export function isUser() {
  const key = Store.state.storageKeys.identity
  const identity = localStorage.getItem(key)
  return identity === 'users' || identity === null
}
